import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeftCircle } from 'react-icons/fi';


import './styles.css';
import api from '../../services/api';

import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import Navperfil from '../Includes/Navperfil';
import perfil from '../../assests/perfil.jpg';
import { calculaTempo } from '../../global';

const BASE_URL = sessionStorage.getItem('BASE_URL');
const USER_EMAIL = sessionStorage.getItem('email');
const USER_TOKEN = sessionStorage.getItem('token');


export default function MeusanunciosAlterar(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const anuncio_id = props.match.params.id;
  const [title, setTitle] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [annoucement_time, setAnnoucement_time] = useState(0);
  const [tag, setTag] = useState('');
  const [tagAn, setTagAn] = useState(pegarTag);
  const [upload, setUpload] = useState(['']);
  const [urlimg, setUrlimg] = useState('');
  const [phone, setPhone] = useState('');
  const [city_code, setCity_code] = useState(0);
  const [state_code, setState_code] = useState(0);
  const [cidades, setCidades] = useState(['']);
  const [nomeCidade, setNomeCidade] = useState('');
  const [livestock_race, setLivestock_race] = useState('');
  const [count, setCount] = useState(0.0);
  const [livestock_age, setLivestock_age] = useState(0);
  const [livestock_weight, setLivestock_weight] = useState(0);
  const [value, setValue] = useState(0);
  const [count_type, setCount_type] = useState('fifteen_kilos');
  const [obs, setObs] = useState('');
  const [erros, setErros] = useState(['']);
  const [original_image_url, setOriginal_image_url] = useState('');
  const [has_video, setHas_video] = useState('');

  function pegarTag() {
    var tags = JSON.parse(sessionStorage.getItem('TAGS'));
    var tagAnuncio = [];

    tags.forEach(tag => {
      if (tag.is_bovine === true) {
        var arr = { 'id': tag.id, 'name': tag.name, 'slug': tag.slug }
        tagAnuncio.push(arr);
      }
    });
    return tagAnuncio;
  }

  useEffect(() => {
    api.get(`/v6/classifieds/${anuncio_id}`, {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    }).then(response => {
      setTitle(response.data.title);
      setMensagem(response.data.description);
      setAnnoucement_time(response.data.annoucement_time);
      if (response.data.annoucement_time === 15) {
        document.getElementById("15").checked = true;
      } else {
        document.getElementById("30").checked = true;
      }
      document.getElementById('txtMsg').value = response.data.description;
      setTag(response.data.category);
      document.getElementById('tag_id').value = response.data.category;
      setUrlimg(response.data.image_url);
      setPhone(response.data.phone);
      setCity_code(response.data.city_info.code);
      setNomeCidade(response.data.city_info.name + ', ' + response.data.state_info.acronym);
      setLivestock_race(response.data.livestock_race);
      setCount(response.data.count);
      setLivestock_age(response.data.livestock_age);
      setLivestock_weight(response.data.livestock_weight);
      setValue(response.data.value);
      setCount_type(response.data.count_type);
      document.getElementById('countType').value = response.data.count_type;
      setObs(response.data.observation);
      setState_code(response.data.state_info.code);
      setOriginal_image_url(response.data.original_image_url);
      setHas_video(response.data.has_video);
      //var check = document.getElementById('video');
      //check.checked = has_video;
      
    }).catch(function (error) {
      setErros(error.response.data.errors);
      //mostrarErros();
    })
  }, [annoucement_time, anuncio_id, has_video, props.match.params.id])
  function mascaraTel(e) {
    if (e.length > 2) {
      e = e.replace(/\D/g, "");
      e = e.replace(/^(\d{2})(\d)/g, "($1) $2");
    }
    setPhone(e);
  }
  function limpaTelefone(phone) {
    var v = phone.replace("(", "");
    v = v.replace(")", "");
    v = v.replace(" ", "");
    setPhone(v);
  }

  function mostrarErros() {
    let msg = document.getElementById('msg');
    msg.style.display = 'block';
    setTimeout(() => {
      msg.style.display = 'none';
    }, 5000)
  }
  function mostrarSuccess() {
    let msg = document.getElementById('success');
    msg.style.display = 'block';
    let btn = document.getElementById('btn-enviar');
    btn.disabled = true;

    setTimeout(() => {
      msg.style.display = 'none';
      history.push('/meus-anuncios')
    }, 5000)
  }

  async function enviarAnuncio(event) {
    event.preventDefault();
    if (!document.getElementById('fileInput').files[0] && !urlimg) {
      setErros([t('pages.changeMyAnnoucements.erros.sendPhoto')]);
      mostrarErros();
      return false;
    }
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('title', title);
    data.append('description', mensagem);
    data.append('phone', phone);
    data.append('category', tag);
    data.append('value', value);
    data.append('observation', obs);
    data.append('has_video', has_video);
    if (document.getElementById('fileInput').files[0]) {
      data.append('image', document.getElementById('fileInput').files[0]);
    } else {
      data.append('image_url', urlimg);
    }
    data.append('original_image_url', original_image_url);
    data.append('annoucement_time', annoucement_time);
    data.append('count', count);
    data.append('count_type', count_type);
    data.append('livestock_weight', livestock_weight);
    data.append('livestock_race', livestock_race);
    data.append('livestock_age', livestock_age);
    data.append('city_code', city_code);
    data.append('state_code', state_code);
    var config = {
      method: 'put',
      url: BASE_URL + `/v6/classifieds/${anuncio_id}`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        //...data.getHeaders()
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        mostrarSuccess();
        setTimeout(() => {
          //history.push(`/negociacoes/${this.state.id}`)
          history.push(`/meus-anuncios`);
        }, 5000);
      })
      .catch(function (error) {
        setErros(error.response.data.errors);
        mostrarErros();
      })
  }
  function Select(props) {
    return (
      <select id="tag_id"
        onChange={e => setTag(e.target.value)}
        value={tag}
      >
        <option value="0">{t('pages.changeMyAnnoucements.selectTag')}</option>
        {
          tagAn.map(tag => (
            <option value={tag.slug} select>{tag.name}</option>
          ))
        }
      </select>
    )
  }
  async function SelectCidade(city) {
    let data = new FormData();
    if (city.length >= 3) {
      await api.get(`/v4/search/cities?term=${city}`, {
        headers: {
          ...data.getHeaders
        }
      }, data).then(function (response) {
        setCidades(response.data);
        document.getElementById("dvCidades").style.display = "block";
      })
    }
  }
  function minhaCidade(id, nome) {
    var cid = id.toString();
    var state = cid.substring(0, 2);
    setCity_code(id);

    setNomeCidade(nome);
    setState_code(state);
    document.getElementById("dvCidades").style.display = "none";
  }
  function AtualizaImagem(e) {
    // const contentType = 'image/jpeg';
    // const blob = new Blob([e]);
    // const blobURL = URL.createObjectURL(blob, {contentType: contentType});
    // setUrlimg(blobURL);
  }
  function alterarTextArea(e, id) {
    setMensagem(e);
  }
  function voltar() {
    history.push('/meus-anuncios')
  }
  function verificaVideo() {
    var video = document.getElementById('video');
    if (video.checked) {
      setHas_video(true);
    } else {
      setHas_video('');
    }
  }
  return (
    <div className="meusanunciosdet-container">
      <Header />
      <Navperfil />
      <TituloPagina titulo={t('pages.changeMyAnnoucements.title')} />
      <section className="body">
        <ul>
          <li key={props.match.params.id}>
            <form className="formAnuncio" onSubmit={enviarAnuncio} ectype="multipart/form-data">
              <div className="titulo">
                {t('pages.changeMyAnnoucements.announcementTitle')}
              </div>
              <div className="campos">
                <input type="text"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                />
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.message')}
              </div>
              <div className="campos">
                <textarea id="txtMsg" onKeyUp={e => alterarTextArea(e.target.value, 'txtMsg')}>{mensagem}</textarea>
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.duration')}
              </div>
              <div className="camposRadio">
                <input type="radio" id="15" name="annoucement_time" value="15"
                  onClick={e => setAnnoucement_time(e.target.value)} 
                />
                <label for="sale">{t('pages.changeMyAnnoucements.biweekly')}</label>
                <input type="radio" id="30" name="annoucement_time" value="30"
                  onClick={e => setAnnoucement_time(e.target.value)} 
                />
                <label for="purchase">{t('pages.changeMyAnnoucements.mounth')}</label>
              </div><div className="titulo">
                {t('pages.changeMyAnnoucements.categories')}
              </div>
              <div className="campos">
                <Select tags={JSON.parse(sessionStorage.getItem("TAGS"))} />
              </div>
              <div className="campos">
                <div>
                  <p>
                    <img src={urlimg} class="preview-img" alt="img" />
                  </p>
                  <p>
                    <input id="fileInput" class="file-chooser" onChange={e => AtualizaImagem(e.target.value)} type="file" accept="image/*" />
                  </p>
                </div>
              </div>
              <div className="clCheck">
                <input type="checkbox" id="video" name="video" onClick={verificaVideo} />
                <label for="scales">{t('pages.changeMyAnnoucements.hasVideo')}</label>
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.telephone')}
              </div>
              <div className="campos">
                <input
                  id="iPhone"
                  name="iPhone"
                  type="tel"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  maxlength="15"
                  onKeyUp={e => mascaraTel(e.target.value)}
                />
              </div>
              <div className="campos">
                <input
                  value={city_code}
                  onChange={e => setCity_code(e.target.value)}
                  id="city_id"
                  className="city_id"
                  name="city_id"
                  type="hidden"
                />
                <input
                  placeholder={t('pages.changeMyAnnoucements.placeholder.city')}
                  onKeyUp={e => SelectCidade(e.target.value)}
                  type="text" name="cidade" id="cidade"
                  value={nomeCidade}
                  onChange={e => setNomeCidade(e.target.value)}
                  autocomplete="off"
                />

              </div>
              <div className="cidades" id="dvCidades">
                {
                  cidades.map(cid => (
                    <div>
                      <Link onClick={() => minhaCidade(cid.code, cid.value)}>{cid.value}</Link>
                    </div>
                  ))
                }
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.breed')}
              </div>
              <div className="campos">
                <input type="text"
                  value={livestock_race}
                  onChange={e => setLivestock_race(e.target.value)}
                />
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.numberHeads')}
              </div>
              <div className="campos">
                <input type="number"
                  value={count}
                  onChange={e => setCount(e.target.value)}
                />
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.ageMounth')}
              </div>
              <div className="campos">
                <input type="text"
                  value={livestock_age}
                  onChange={e => setLivestock_age(e.target.value)}
                />
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.weightKG')}
              </div>
              <div className="campos">
                <input type="text"
                  value={livestock_weight}
                  onChange={e => setLivestock_weight(e.target.value)}
                />
              </div>
              <div className="campos50">
                <div className="titulo">
                  {t('pages.changeMyAnnoucements.price')}
                </div>
                <div className="campos50">
                  <input type="number"
                    value={value}
                    onChange={e => setValue(e.target.value)}
                  />
                </div>
                <select name="" id="countType"
                  value={count_type}
                  onChange={e => setCount_type(e.target.value)}
                >
                  <option value="fifteen_kilos">{t('pages.changeMyAnnoucements.fifteenKilos')}</option>
                  <option value="sacs">{t('pages.changeMyAnnoucements.telephone')}</option>
                  <option value="tons">{t('pages.changeMyAnnoucements.tons')}</option>
                  <option value="head">{t('pages.changeMyAnnoucements.heads')}</option>
                  <option value="live_kilos">{t('pages.changeMyAnnoucements.liveKilos')}</option>
                </select>
              </div>
              <div className="titulo">
                {t('pages.changeMyAnnoucements.observation')}
              </div>
              <div className="campos">
                <input type="text"
                  value={obs}
                  onChange={e => setObs(e.target.value)}
                />
              </div>
              <div className="success" id="success">
                <p><strong>{t('pages.changeMyAnnoucements.success')}</strong></p>
              </div>
              {

              }
              <div className="alert" id="msg">
                <p><strong>{t('pages.changeMyAnnoucements.error')}</strong></p>
                {erros.map(err => (
                  <p>- {err}</p>
                ))}
              </div>
              <div className="campos">
                <button className="btn-enviar" id="btn-enviar" type="submit">{t('pages.changeMyAnnoucements.send')}</button>
              </div>
            </form>
          </li>
        </ul>
      </section>
      <section className="paginacao">
        <div className="proxima">
          <a href>
            <span onClick={voltar}><FiArrowLeftCircle />{t('pages.changeMyAnnoucements.back')}</span>
          </a>
        </div>
      </section>
      <Footer />
    </div>
  )
}